import { NumericFormat } from "react-number-format";

interface Props {
  value: number;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  thousandSeparator?: boolean;
  prefix?: string;
}

export const PriceFormat = ({
  value,
  decimalScale = 2,
  fixedDecimalScale = true,
  thousandSeparator = true,
  prefix = "€"
}: Props) => {
  return (
    <NumericFormat
      value={value}
      displayType={"text"}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      thousandSeparator={thousandSeparator}
      prefix={prefix}
      allowNegative={!prefix.startsWith("-")}
    />
  );
};
